module.exports = __webpack_public_path__ + "img/grs-hero.4b0322df.png";